// @dynamic

export class AOFake {

  static floorDecimal(value, decimals = 2) {
    return Math.floor(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  }

  static randomFloat(min = 0, max = 100, decimals = 2) {
    return Math.floor((min + (Math.random() * (max - min))) * Math.pow(10, decimals)) / Math.pow(10, decimals);
  }

  static randomInteger(min = 0, max = 100) {
    return Math.floor((min + (Math.random() * (max - min))) * Math.pow(10, 0)) / Math.pow(10, 0);
  }

  static randomChar(chars = 'qwertyuiopasdfghjklzxcvbnm1234567890') {
    return chars.charAt(this.randomInteger(0, chars.length - 1));
  }

  static randomWord(min = 1, max = 10) {
    const size = this.randomInteger(min, max);
    let word = '';
    while (word.length < size) {
      word += this.randomChar();
    }
    return word;
  }

  static randomWords(min = 1, max = 10) {
    const qt = this.randomInteger(min, max);
    const words = [];
    while (words.length < qt) {
      words.push(this.randomWord());
    }
    return words.join(' ');
  }

  static randomBoolean(fator = 50) {
    return this.randomInteger() <= fator;
  }

  static randomElement(elements: any[]) {
    return elements[this.randomInteger(0, elements.length - 1)];
  }

  static randomElements(elements: any[], min = 1, max = null) {
    min = min && min > 1 ? Math.floor(min) : 1;
    max = max && max < elements.length ? Math.floor(max) : this.randomInteger(min, elements.length - 1);
    const qt = this.randomInteger(min, max);
    const selection: any[] = [];
    while (selection.length < qt) {
      selection.push(this.randomElement(elements));
    }
    return selection;
  }

}
